import {
  getApiV1ThreeLetterCodePartnerAdminsContractPlansId,
  getGetApiV1ThreeLetterCodePartnerAdminsContractPlansIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsContractPlansId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** パートナーの 3 文字コード */
  threeLetterCode: string;
  /** 契約プラン ID */
  planId: number;
};

type ReturnType = {
  /** 契約プラン詳細データ */
  data: GetApiV1ThreeLetterCodePartnerAdminsContractPlansId200;
};

type IUseGetPartnerAdminsContractPlan = (args: Args) => ReturnType;

/**
 * パートナー管理者向け契約プラン詳細取得フック
 *
 * - Suspense を使用してデータを取得する
 * - 廃止済みプランも表示する（一覧と同じ方針）
 */
export const useGetPartnerAdminsContractPlan: IUseGetPartnerAdminsContractPlan = ({
  threeLetterCode,
  planId,
}) => {
  const { data } = useFetch<GetApiV1ThreeLetterCodePartnerAdminsContractPlansId200>(
    getGetApiV1ThreeLetterCodePartnerAdminsContractPlansIdKey(threeLetterCode, planId),
    () => getApiV1ThreeLetterCodePartnerAdminsContractPlansId(threeLetterCode, planId),
    { suspense: true }
  );

  return {
    data,
  };
};
